<app-reports
  title="Manufacturer Restricted NDC Reports"
  [reportsUrl]="reportsUrl" />
